import { render, staticRenderFns } from "./ChatbotParamSetting.vue?vue&type=template&id=3cc7a8cd"
import script from "./ChatbotParamSetting.vue?vue&type=script&lang=js"
export * from "./ChatbotParamSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports